export default __webpack_public_path__ + "static/media/topic6.587178b7.png";